import React from 'react';
import Markdown from 'react-markdown';

function ChatMessages({ messages, user, bot, loading, toggleShowToolCalls }) {
    return (
         <div className='chat-body' style={{ backgroundColor: '#fff' }}>
            {messages.map((message, index) => (
                <div key={index} className={`message-row`}>
                    {message.role === "info" || message.role === "system" ? (
                        <div className="chat-info-message">{message.content}</div>
                    ) : message.sender === user.id ? (
                        <div className="chat-bubble-right">{message.text}</div>
                    ) : (
                        <>
                            <div className='chat-bubble-left'>
                                <Markdown>{message.text}</Markdown>
                                {message.toolCallsMadeAndResponses && message.toolCallsMadeAndResponses.length > 0 && (
                                    <>
                                        <button className='btn btn-link text-primary text-bold' onClick={() => toggleShowToolCalls(index)} disabled={loading}>
                                            Show tool calls and responses <i className="fa-solid fa-chevron-down"></i>
                                        </button>
                                        {message.showToolCalls && (
                                            <div className='d-flex flex-column'>
                                                {message.toolCallsMadeAndResponses.map((toolCallAndResponse, idx) => (
                                                    <div key={idx} className='d-flex flex-column'>
                                                        <div>Tool: </div>
                                                        <div>{toolCallAndResponse.toolCall}</div>
                                                        <div>{JSON.stringify(toolCallAndResponse.response, null, 2)}</div>
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </>
                                )}
                            </div>
                        </>
                    )}
                </div>
            ))}
        </div>
    );
}

export default ChatMessages;
